import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createTag } from '../../api/tag.ts';
import { CreateTagRequest } from '../../api/requests/tag-request.ts';

export default function useCreateTag(): UseMutationResult<
  Awaited<ReturnType<typeof createTag>>,
  Error,
  CreateTagRequest
> {
  return useMutation({
    mutationFn: createTag,
  });
}
